module.exports = __webpack_public_path__ + "static/media/yolanda_ying_yu_chen.e84c968f.jpg";